const priceText = ({ price, provider }) => {
  if (provider === 'C1') {
    if ([1607, 2225, 3090].includes(price?.amount)) return 'POA'
  }
  return price?.text || 'POA'
}

export { priceText }
